import Notifications from 'vue-notification'
import _ from "lodash";

export default {
    install(Vue) {
        Vue.use(Notifications);

        Vue.mixin({
            provide() {
                return _.pickBy({
                    notifyOptions: this.notifyOptions,
                });
            },
            inject: {
                parentNotifyOptions: {
                    from: 'notifyOptions',
                    default: () => ({}),
                },
            },
            methods: {
                showNotify(type, text, duration, options = {}) {
                    return this.$notify(Object.assign({
                        duration: duration,
                    }, this.notifyOptions || this.parentNotifyOptions, options, {
                        type: type,
                        text: text,
                    }));
                },
                notifySuccess(text, notifyOptions = {}) {
                    return this.showNotify('success', text, 5000, notifyOptions);
                },
                notifyError(err, notifyOptions = {}) {
                    const text = err?.response?.data?.error?.description || err?.message || err;
                    return this.showNotify('error', text, 30000, notifyOptions);
                },
                notifyWarn(text, notifyOptions = {}) {
                    return this.showNotify('warn', text, 15000, notifyOptions);
                },
            },
        });
    },
};
